import { TextField } from '@/components/form/fields/text/TextInput';
import { FunctionComponent } from 'react';

interface ContactInformationFieldProps {
  fieldKey?: string;
  readonly?: boolean;
  nameFieldId?: string;
}

const ContactInformationField: FunctionComponent<ContactInformationFieldProps> = ({ fieldKey = '', readonly, nameFieldId }) => {
  const fieldPrefix = fieldKey ? `${fieldKey}.` : '';

  return (
    <div className="flex flex-col space-y-4 pt-2">
      <div className="flex flex-row space-x-5">
        {nameFieldId && (
          <TextField className="flex-1" readonly={readonly} id={nameFieldId} label="Recipient Name" />
        )}
        <TextField
          className="flex-1"
          readonly={readonly}
          id={`${fieldPrefix}contact.telephoneNumber`}
          label="Mobile Number"
        />
      </div>
      <div className="flex flex-row space-x-5">
        <TextField className="flex-1" readonly={readonly} id={`${fieldPrefix}contact.workEmail`} label="Work Email" />
        <TextField
          className="flex-1"
          readonly={readonly}
          id={`${fieldPrefix}contact.personalEmail`}
          label="Personal Email (for new hires)"
          optional
        />
      </div>
    </div>
  );
};

export default ContactInformationField;
